import {Component, Input, OnDestroy, AfterViewInit, OnInit} from '@angular/core';
import {ChanelInterface} from '@core/interfaces';
import { UserInfoService } from '@core/services/user-info.service';

@Component({
    selector: 'app-channel-info',
    templateUrl: 'channel-info.component.html',
    styleUrls: ['channel-info.component.scss']
})

export class ChannelInfoComponent implements OnInit, OnDestroy, AfterViewInit {
    @Input() channelData: ChanelInterface;
    @Input() editPermission: boolean;
    public coverImgSrc: string | undefined;
    public avatarImgSrc: string | undefined;

    constructor(
        private _userInfoService: UserInfoService,
    ) {
    }

    ngOnInit() {

    }

    ngAfterViewInit() {
        this._userInfoService._getCurrentUserInfo();
    }


    ngOnDestroy() {
    }
}
